import BaseModelAPI from '../BaseModelAPI';

export default class PartGoodReceiptList extends BaseModelAPI {

	static entity = 'partgoodreceiptlist'
	static entityName = 'partgoodreceipt';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
